// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";
import { css } from "styled-components";

export interface PasswordRequirementsPresentationProps extends ExpandStyles<PasswordRequirementsStyles> {
    /* Store Custom Code - Start */
    showTitle?: boolean;
    /* Store Custom Code - End */
}

export interface PasswordRequirementsProps extends PasswordRequirementsPresentationProps {}

export interface PasswordRequirementsStyles {
    wrapper?: InjectableCss;
    title?: TypographyProps;
    list?: InjectableCss;
    listItem?: InjectableCss;
}

const passwordRequirementsStyles: PasswordRequirementsStyles = {
    wrapper: {
        css: css`
            ${boxStyles()}

            ${breakpoint("md", "down")} {
                width: 100%;
            }
        `,
    },
    title: {
        variant: "h4",
        forwardAs: "h2",
    },
};

const PasswordRequirements: FC<PasswordRequirementsProps> = ({
    extendedStyles,
    overridedStyles,
    // Store Custom Code
    showTitle = true,
}) => {
    const accountSettings = useSettingsCollection().accountSettings;
    const styles = useExpandProps(passwordRequirementsStyles, extendedStyles, overridedStyles);

    const {
        passwordMinimumLength,
        passwordRequiresUppercase,
        passwordRequiresSpecialCharacter,
        passwordRequiresLowercase,
        passwordRequiresDigit,
    } = accountSettings;

    return (
        <StyledWrapper {...styles.wrapper}>
            {/* Store Custom Code - Start */}
            {showTitle && <Typography {...styles.title}>{translate("Password Requirements")}</Typography>}
            {/* Store Custom Code - End */}
            <UnorderedList {...styles.list}>
                <ListItem {...styles.listItem}>
                    {/* Store Custom Code - Start */}
                    {translate("At least {0} characters long", passwordMinimumLength.toString())}
                    {/* Store Custom Code - End */}
                </ListItem>
                {passwordRequiresDigit && (
                    /* Store Custom Code - Start */
                    <ListItem {...styles.listItem}>{translate("Include at least one number")}</ListItem>
                    /* Store Custom Code - End */
                )}
                {passwordRequiresLowercase && (
                    <ListItem {...styles.listItem}>
                        {translate("Include at least one lowercase character") /* Store Custom Code */}
                    </ListItem>
                )}
                {passwordRequiresUppercase && (
                    <ListItem {...styles.listItem}>
                        {translate("Include at least one uppercase character") /* Store Custom Code */}
                    </ListItem>
                )}
                {passwordRequiresSpecialCharacter && (
                    <ListItem {...styles.listItem}>
                        {translate("Include at least one non alphanumeric character") /* Store Custom Code */}
                    </ListItem>
                )}
            </UnorderedList>
        </StyledWrapper>
    );
};

export default PasswordRequirements;
